import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IAccessibleViewInformationService = ( createDecorator('accessibleViewInformationService'));
export { IAccessibleViewInformationService };
